<template>
  <div class="main tabs_main" style="height:89%">
    <div class="main_header">
      <div class="header_item">
        <span class="header_label">钢筋名称型号：</span>
        <el-select v-model="search.steelId" placeholder="请选择钢筋名称" clearable>
            <el-option
            v-for="item in optionsRebar"
            :key="item.steelId"
            :label="item.steelName+'-'+item.steelModel"
            :value="item.steelId">
            </el-option>
        </el-select>
      </div>
      <!-- <div class="header_item">
        <span class="header_label">规格型号：</span>
        <el-select v-model="search.supplierType" placeholder="请选择规格型号">
            <el-option
            v-for="item in optionsModels"
            :key="item.dictId"
            :label="item.dictName"
            :value="item.dictId">
            </el-option>
        </el-select>
      </div> -->
      <div class="header_item">
        <span class="header_label">供应商：</span>
        <el-select v-model="search.supplierId" placeholder="请选择供应商" clearable>
            <el-option
            v-for="item in optionsSupplierType"
            :key="item.id"
            :label="item.supplierName"
            :value="item.id">
            </el-option>
        </el-select>
      </div>
      <!-- <div class="header_item">
        <span class="header_label">厂家：</span>
        <el-input v-model="search.factoryName" :size="size" clearable placeholder="请输入厂家"></el-input>
      </div> -->
      <div class="header_item">
        <span class="header_label">入库时间：</span>
        <el-date-picker
            v-model="search.time"
            type="daterange"
            :default-time="['00:00:00','23:59:59']"
            clearable
            value-format="yyyy-MM-dd HH:mm:ss"
            range-separator="-"
            start-placeholder="起始时间"
            end-placeholder="结束时间">
        </el-date-picker>
      </div>
      <div class="header_item">
        <el-button icon="el-icon-search" v-if="showButton('search')" @click="searchButtonInfo(true)">查询</el-button>
        <el-button class="search_btn" icon="el-icon-plus" v-if="showButton('insert')" @click="insertProp">新增</el-button>
        <el-button icon="el-icon-upload2" v-if="showButton('export')" @click="exportIncomeDatas">导出Excel</el-button>
        <el-button icon="el-icon-postcard" v-if="showButton('export')" @click="exportIncomeFile">导出模板</el-button>
        <el-upload
              class="upload-demo"
              style="margin-left:10px"
              action=""
              :multiple="false"
              :http-request="httpRequest"
              :show-file-list="false"
              :file-list="fileList">
              <el-button icon="el-icon-download"  v-if="showButton('exportIn')" :size="size">导入Excel</el-button>
        </el-upload>
      </div>
    </div>
    <div class="main_content">
      <el-table
        v-loading="loading"
        :data="dataList"
        height="100%">
        <el-table-column align="center" label="序号" width="60">
          <template #default="scope">
            <span>{{(pageNum - 1) * pageSize + scope.$index + 1}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="入库时间" align="center" width="180"></el-table-column>
        <el-table-column prop="supplierName" label="供应商" align="center" width="120"></el-table-column>
        <!-- <el-table-column prop="factoryName" label="厂家" align="center"  show-overflow-tooltip></el-table-column>
        <el-table-column prop="brand" label="品牌" align="center" ></el-table-column> -->
        <el-table-column prop="steelName" label="钢筋名称" align="center"  show-overflow-tooltip></el-table-column>
        <!-- <el-table-column prop="carName" label="车牌号" align="center" ></el-table-column> -->
        <el-table-column prop="steelModel" label="规格型号" align="center" ></el-table-column>
        <el-table-column prop="changeStock" label="入库重量" align="center" ></el-table-column>
        <el-table-column prop="unit" label="计量单位" align="center"  show-overflow-tooltip></el-table-column>
        <el-table-column prop="realName" label="入库人" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column label="操作" align="center">
          <template #default="{ row }">
            <el-button class="delete_btn" size="mini" v-if="showButton('delete')" @click="deleteInfo(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="main_footer">
      <el-pagination
        background
        @current-change="changePageNum"
        @size-change="changePageSize"
        :current-page="pageNum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <el-dialog
      class="prop_dialog"
      :title="asyncTitle ? '新增入库' : '修改入库信息'"
      :close-on-click-modal="false"
      :visible.sync="asyncVisible"
      width="35%">
      <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="auto" class="rule_form">
        <el-form-item label="钢筋名称型号：" prop="steelId">
          <el-select v-model="ruleForm.steelId" :size="size" placeholder="请选择钢筋名称">
            <el-option
            v-for="item in optionsRebar"
            :key="item.steelId"
            :label="item.steelName+'-'+item.steelModel"
            :value="item.steelId">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="规格型号：" prop="supplierType">
           <el-select v-model="ruleForm.supplierType" :size="size" placeholder="请选择规格型号">
                <el-option
                v-for="item in optionsModels"
                :key="item.dictId"
                :label="item.dictName"
                :value="item.dictId">
                </el-option>
            </el-select>
        </el-form-item> -->
        <el-form-item label="入库时间：" prop="createTime">
          <el-date-picker
            v-model="ruleForm.createTime"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="datetime"
            :size="size"
            clearable
            placeholder="请选择入库时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="入库重量：" prop="changeStock">
          <el-input v-model="ruleForm.changeStock" :size="size" type="number" clearable placeholder="请输入入库重量"></el-input>
        </el-form-item>
        <el-form-item label="供应商：" prop="supplierId">
            <el-select v-model="ruleForm.supplierId" placeholder="请选择供应商">
                <el-option
                v-for="item in optionsSupplierType"
                :key="item.id"
                :label="item.supplierName"
                :value="item.id">
                </el-option>
            </el-select>
        </el-form-item>
        <!-- <el-form-item label="厂家：" prop="factoryName">
          <el-input v-model="ruleForm.factoryName" :size="size" clearable placeholder="请输入厂家"></el-input>
        </el-form-item>
        <el-form-item label="品牌：" prop="brand">
          <el-input v-model="ruleForm.brand" :size="size" clearable placeholder="请输入品牌"></el-input>
        </el-form-item> -->
      </el-form>
      <div slot="footer">
        <el-button @click="asyncVisible = false">取 消</el-button>
        <el-button class="submit_btn" @click="asyncTitle ? submitInsert() : submitUpdate()">提 交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { buttonPinia } from '../../../pinia/index';
import { throttle, changeSize,downFiles } from '../../../plugins/public'; // 导入节流、动态切换组件尺寸方法
  export default {
    data() {
      return {
        size: changeSize(), // 组件尺寸
        pageNum: 1,
        pageSize: 10,
        search:{},//查询条件
        total: 0,
        loading: false,
        dataList: [], //入库记录信息列表
        asyncTitle: true, // 对话框title 新增：true  修改：false
        asyncVisible: false, // 添加 修改对话框
        ruleForm: {
        }, // 按钮表单
        rules: {
          steelId: [{
            required: true,
            message: '请选择钢筋名称型号',
            trigger: 'change'
          }],
          createTime: [{
            required: true,
            message: '请选择入库时间',
            trigger: 'change'
          }],
          changeStock: [{
            required: true,
            message: '请输入入库重量',
            trigger: 'blur'
          }],
          supplierId: [{
            required: true,
            message: '请选择供应商',
            trigger: 'change'
          }],
          factoryName: [{
            required: true,
            message: '请输入厂家',
            trigger: 'blur'
          }],
          brand: [{
            required: true,
            message: '请输入品牌',
            trigger: 'blur'
          }],
        },
        optionsRebar:[],//钢筋名称
        optionsModels:[],//规格型号
        optionsSupplierType:[],//供应商
        fileList:[],//导入
      }
    },
    watch: {
      asyncVisible(bol) {
        if(!bol) {
          this.ruleForm = {};
          this.$refs.ruleForm.resetFields();
        }
      }
    },
    mounted() {
      const that = this;
      // 根据窗口大小动态修改组件尺寸
      window.onresize = () => {
        that.size = changeSize();
      }
      that.getAllTypes()
    //   that.getNameList()
    },
    methods: {
    //获取所有钢筋名称
      getNameList(){
        let params = {
            pageNum: 1,
            pageSize: 100000000
        }
        this.$api.Rebar.searchType(params).then(res=>{
            if(res.statusMsg ==='ok'){
                this.optionsRebar = res.data.list
            }else{
                this.$message.warning(res.statusMsg)
            }
        })
      },
    //导出Excel数据
    exportIncomeDatas(){
      this.functionLoading();
        let params  = Object.assign({},this.search,{
            stockType:1
        })
        this.$api.Rebar.exportPutDatas(params).then(res => {
            downFiles(res, '入库记录信息', 'xls')
            this.loadingView.close()
        })
        .catch(() => {
          this.loadingView.close();
        })
    },
    //自定义上传
    httpRequest({file}){
        this.functionLoading();
        const formData = new FormData();
        formData.set('file', file);
        this.$api.Rebar.exportIncome(formData).then((res) => {
          if(res.success) {
            this.searchButtonInfo();
            this.$message.success('上传成功！');
            this.loadingView.close();
          } else {
            this.$message.warning(typeof(res.data) === 'object' ? res.statusMsg : res.data);
            this.loadingView.close();
          }
        })
        .catch(() => {
          this.$message.error('请检查网络设置！');
          this.loadingView.close();
        })
    },
    //获取供应商信息
      getAllTypes(){
        let params = {
            pageNum: 1,
            pageSize: 100000000
        }
        this.$api.Supplier.searchSupplier(params).then(res=>{
            if(res.statusMsg === 'ok'){
                this.optionsSupplierType = res.data.list
            }else{
                this.$message.warning(res.statusMsg)
            }
        })
      },
      // 转圈圈
      functionLoading() {
        this.loadingView = this.$loading({
          lock: true,
          text: '请稍后...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      },
      //导出
      exportIncomeFile() {
        this.functionLoading();
        this.$api.Rebar.exportFiles({}).then(res => {
          if(res.success === false){
            this.loadingView.close()
            this.$message.warning(res.statusMsg)
          }else{
            downFiles(res, '入库记录信息模板', 'xls')
            this.loadingView.close()
          }
        })
        .catch(() => {
          this.loadingView.close();
        })
      },
      // 查询按钮列表信息
      searchButtonInfo(bol) {
        if(bol) {
          this.pageNum = 1;
        }
        let params = Object.assign({},this.search,{
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          stockType:1
        })
        params.strTime = this.search.time&&this.search.time[0]
        params.endTime = this.search.time&&this.search.time[1]
        delete params.time
        this.loading = true;
        this.$api.Rebar.searchIncome(params).then((res) => {
          if(res.statusMsg === 'ok') {
            this.total = res.data.total;
            this.dataList = res.data.list;
          }else{
            this.$message.warning(res.statusMsg)
          }
          this.loading = false;
        })
      },
      // 新增按钮信息
      insertProp() {
        this.asyncTitle = true;
        this.asyncVisible = true;
      },
      // 删除按钮信息
      deleteInfo(row) {
        this.$confirm("该操作将删除该信息，是否继续删除?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
       })
       .then(() => {
         this.$api.Rebar.deleteIncome({id: row.id})
        .then(res => {
          if(res.statusMsg === 'ok') {
            this.searchButtonInfo(true);
            this.$message.success("删除成功！");
          } else {
            this.$message.warning(res.statusMsg);
          }
        })
       })
       .catch(() => {
         this.$message.warning("您已取消");
       })
      },
      // 提交添加按钮信息
      submitInsert: throttle(function() {
        this.$refs.ruleForm.validate((valid) => {
          if(valid) {
            const params = Object.assign({}, this.ruleForm);
            params.changeStock = this.ruleForm.changeStock*1
            params.stockType = 1
            this.$api.Rebar.insertIncome(params).then((res) => {
              if(res.statusMsg === 'ok') {
                this.asyncVisible = false;
                this.searchButtonInfo(true);
                this.$message.success('添加成功！');
              } else {
                this.$message.warning(res.statusMsg);
              }
            })
          }
        })
      }, 3000),
      // 判断按钮权限信息
      showButton(str) {
        const pinia = buttonPinia();
        return pinia.$state.buttonInfo.includes(str);
      },      
      // 切换页数
      changePageNum(page) {
        this.pageNum = page;
        this.searchButtonInfo();
      },
      // 切换每页条数
      changePageSize(size) {
        this.pageSize = size;
        this.searchButtonInfo();
      }
    }
  }
</script>

<style lang="scss" scoped>
@import '../../../style/layout-main.scss';
</style>